import "./styles.scss";

import { useTranslation } from "react-i18next";
import classnames from "classnames";

import { ReactComponent as ArrowIcon } from "assets/icons/new/forward-arrow.svg";
import { ReactComponent as ViewIcon } from "assets/icons/new/view.svg";

const mainClass = "new-website-content__nav-mobile";

const NavMobile = ({
  isNextDisabled,
  isLoading,
  isPayment,
  onClick,
  onBack,
}) => {
  const { t } = useTranslation();

  return (
    <div className={mainClass}>
      {typeof onBack === "function" && (
        <button
          className={`${mainClass}__button ${mainClass}__button--back`}
          type="button"
          onClick={onBack}
        >
          <i>
            <ArrowIcon />
          </i>
          {t("Back")}
        </button>
      )}
      <button
        className={classnames(`${mainClass}__button`, {
          [`${mainClass}__button--payment`]: isPayment,
        })}
        type={typeof onClick === "function" ? "button" : "submit"}
        disabled={isNextDisabled || isLoading}
        onClick={onClick}
      >
        {t(isPayment ? "Payment" : "Next step [ALT]")}
        {isPayment && (
          <i>
            <ViewIcon />
          </i>
        )}
      </button>
    </div>
  );
};

export default NavMobile;
